import {BigInput} from "../../forms/bigInput/BigInput";
import TextAreaNext from "../../forms/textAreaNext/TextAreaNext";
import Checkbox from "../../forms/checkbox/Checkbox";
import Sunglasses from "../../../assets/images/sunglasses.png";
import {getPlaceholdersByTriggerIdAndConsent} from "../../../utils/getPlaceholdersByTriggerIdAndConsent";
import {SHIPMENT_FLOW_TRIGGER_IDS} from "../../../consts/SHIPMENT_FLOW_TRIGGER_IDS";
import {Button, Dropdown, MenuProps} from "antd";
import {LANGUAGES} from "../../../utils/languages";
import LanguagePicker from "../../forms/languagePicker/LanguagePicker";
import ButtonGroup from "../../forms/buttonGroup/ButtonGroup";
import React, {ReactNode, useEffect, useState} from "react";
import FieldContainer from "../../forms/fieldContainer/FieldContainer";
import ImagePicker from "../../forms/imagePicker/ImagePicker";
import {uploadImage} from "../../../api/uploadImage";
import {ToastSkin} from "../../../context/ToastContext";
import useUserContext from "../../../hooks/useUserContext";
import useToast from "../../../hooks/useToast";
import TemplateImagePicker from "../../forms/teplateImagePicker/TemplateImagePicker";

interface Step1FieldsProps {
    id?: number;
    title: string;
    setTitle: (newVal: string) => void;
    content: string;
    setContent: (newVal: string) => void;
    isCoupon: boolean;
    setIsCoupon: (newVal: boolean) => void;
    isWithImage: boolean;
    setIsWithImage: (newVal: boolean) => void;
    imageUrl?: string;
    setImageUrl?: (newVal: string) => void;
    flowTriggerId?: number;
    isCampaign?: boolean;
    requiresConsent?: boolean;
    setRequiresConsent?: (newVal: boolean) => void;
    language: string;
    setLanguage: (newLang: string) => void;
    direction?: 'ltr' | 'rtl';
    setIsLoading?: (newState: boolean) => void;
    button1Url?: string;
    setButton1Url?: (newVal: string) => void;
}

const Step1Fields = ({
    id,
    direction = 'ltr',
    title, setTitle,
    language, setLanguage,
    content, setContent,
    isCoupon, setIsCoupon,
    isWithImage, setIsWithImage,
    imageUrl,
    setImageUrl,
    flowTriggerId,
    requiresConsent = false,
    setRequiresConsent,
    isCampaign = false,
    setIsLoading,
    button1Url = '', setButton1Url,
}: Step1FieldsProps) => {
    const {selectedDomain} = useUserContext();
    const noConsentNote = <div>Note: This message cannot include marketing content (e.g., ads, promotions) as it will be sent without customer consent. Keep it strictly informational. <span onClick={() => window.open('/docs/customer-consent')}>read more about Customer Consent</span></div>
    const couponCodeNote = <div>Please note that in case no coupons are available, the message will not be sent. <span onClick={() => window.open('/docs/coupons')}>read more about Generated Coupons</span></div>;
    const flowTriggersWithNoImage = SHIPMENT_FLOW_TRIGGER_IDS;
    const [contentErrors, setContentErrors] = useState<string[]>([]);

    useEffect(() => {
        const core = String.raw`\{\{\s*([A-Za-z0-9]+(?:\s+[A-Za-z0-9]+)*)\s*\}\}`;
        const startsWithParam = (s: string) => new RegExp(`^\\s*[\\p{P}\\s]*${core}`, "u").test(s);
        const endsWithParam = (s: string) => new RegExp(`${core}\\s*[\\p{P}\\s]*$`, "u").test(s);
        // const endsWithParam = (s: string) => /\{\{\s*([A-Za-z0-9]+(?:\s+[A-Za-z0-9]+)*)\s*\}\}\s*[\p{P}\s]*$/u.test(s);
        const nextErrors = [];
        if(startsWithParam(content) || endsWithParam(content)) {
            nextErrors.push('WhatsApp often rejects templates starting or ending with a placeholder (e.g. {{shop}}). Add a short word before or after the placeholder.')
        }
        setContentErrors(nextErrors);
    }, [content]);

    return (
        <>
            <div className="fields-flex">
                <BigInput value={title} setValue={setTitle} direction={direction} className='title-input' containerClassName='title-input-container' placeholder='Your Message Title' description="Internal title only — not visible to clients." />
                <LanguagePicker onClick={setLanguage} selectedKey={language} />
            </div>
            {/*<Checkbox*/}
            {/*    isSelected={isCoupon}*/}
            {/*    setIsSelected={setIsCoupon}*/}
            {/*    label="Include a coupon if available"*/}
            {/*    description="Add a product coupon (if available) to your template to incentivize your clients to complete their order. Note that if no coupon is available for any of the products, the message will not be sent."*/}
            {/*/>*/}

            {flowTriggerId && flowTriggerId > 1 && setRequiresConsent ?
                <FieldContainer description="Will your new template be used for marketing purposes or for informative notifications for your customers?">
                    <ButtonGroup
                        items={[
                            { title: 'Marketing', id: 1, isSelected: requiresConsent },
                            { title: 'Utility', id: 2, isSelected: !requiresConsent }
                        ]}
                        onClick={(newId: string | number) => {
                            setRequiresConsent(flowTriggerId > 1 && newId === 1)
                        }}
                    />
                </FieldContainer>
            : null}

            <TextAreaNext
                value={content}
                setValue={setContent}
                helpers={{
                    title: 'Use placeholders helpers',
                    options: getPlaceholdersByTriggerIdAndConsent(requiresConsent, flowTriggerId)
                }}
                guide='This is the content that will be sent to your client.' //You can choose from a variety of pre-made templates we created for you, or create a unique one of your own'
                note={flowTriggerId && flowTriggerId > 1 && !requiresConsent ? noConsentNote : content.includes('{{coupon code}}') ? couponCodeNote : null}
                direction={direction}
                errors={contentErrors}
            />
            {isCampaign || (flowTriggerId && flowTriggersWithNoImage.includes(flowTriggerId)) ? null :
                <Checkbox
                    isSelected={isWithImage}
                    setIsSelected={setIsWithImage}
                    label="Include product image if available"
                    imageUrl={Sunglasses}
                    description="Add a product image (if available) to your template to significantly increase the conversions of this message"
                />
            }
            {isCampaign && setImageUrl ? <TemplateImagePicker imageUrl={imageUrl} setImageUrl={setImageUrl} setIsLoading={setIsLoading} />  : null}
            {isCampaign && setButton1Url ? <BigInput value={button1Url} placeholder={selectedDomain} setValue={setButton1Url} description="Where should the action button redirect? If left empty, it defaults to your shop's homepage." /> : null}
        </>
    )
}

export default Step1Fields;